import { TechnologicalSolution } from "@/@types";
import { ApiClient } from "../../ApiClient"
import { GetTechnologicalSolutionResponse } from "../schema/GetTechnologicalSolutionResponse";
import { mapTechnologicalSolution } from "../../mappers/technologicalSolutions/technologicalSolutionMapper";

export const getTechnologicalSolution = async (slug: string): Promise<TechnologicalSolution | null> => {
    const client = ApiClient.getInstance();

    try {
        const response = await client.get<GetTechnologicalSolutionResponse>(`technological-solutions/solution/${slug}`);
        return response.data ? mapTechnologicalSolution(response.data) : null;
    } catch (error: any) {
        return null;
    }
};
